import { render } from "./paymentTypeImage.vue?vue&type=template&id=04013d2a&scoped=true&ts=true"
import script from "./paymentTypeImage.vue?vue&type=script&lang=ts"
export * from "./paymentTypeImage.vue?vue&type=script&lang=ts"

import "./paymentTypeImage.vue?vue&type=style&index=0&id=04013d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04013d2a"],['__file',"src/components/paymentTypeImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04013d2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04013d2a', __exports__)) {
    api.reload('04013d2a', __exports__)
  }
  
  module.hot.accept("./paymentTypeImage.vue?vue&type=template&id=04013d2a&scoped=true&ts=true", () => {
    api.rerender('04013d2a', render)
  })

}


export default __exports__